import { Constants } from "./constants";

/**
 * AKC Obedience / Rally classes that include jumps.
 * Matches the registration FormBuilder check: these are the only levels that
 * require an obedience / rally jump height on the dog before they can be entered.
 */
export const AKC_OBEDIENCE_JUMP_HEIGHT_LEVELS: string[] = [
  Constants.dog_class_element_level.graduate_novice,
  Constants.dog_class_element_level.open_a,
  Constants.dog_class_element_level.open_b,
  Constants.dog_class_element_level.preferred_open,
  Constants.dog_class_element_level.graduate_open,
  Constants.dog_class_element_level.utility_a,
  Constants.dog_class_element_level.utility_b,
  Constants.dog_class_element_level.preferred_utility,
];

export const AKC_RALLY_JUMP_HEIGHT_LEVELS: string[] = [
  Constants.dog_class_element_level.advanced_a,
  Constants.dog_class_element_level.advanced_b,
  Constants.dog_class_element_level.excellent_a,
  Constants.dog_class_element_level.excellent_b,
  Constants.dog_class_element_level.master,
];

/**
 * CKC Obedience classes that include jumps (Obedience Trial Rules 8.20.3, 11.8, 12.9, 13.10, 16.2).
 * These are the only CKC levels that require a CKC obedience jump height before they can be entered.
 */
export const CKC_OBEDIENCE_JUMP_HEIGHT_LEVELS: string[] = [
  Constants.dog_class_element_level.ckc_novice_intermediate,
  Constants.dog_class_element_level.open_a,
  Constants.dog_class_element_level.open_b,
  Constants.dog_class_element_level.utility_a,
  Constants.dog_class_element_level.utility_b,
  Constants.dog_class_element_level.wc_open,
  Constants.dog_class_element_level.wc_utility,
  Constants.dog_class_element_level.graduate_open,
  Constants.dog_class_element_level.ckc_pre_open,
  Constants.dog_class_element_level.ckc_pre_utility,
];

/**
 * CKC Rally Obedience classes that include jumps (Rally Obedience Trial Rules 8.18.4(b)(i)).
 * The jump height is declared on the entry form (8.18.4(b)(ii)).
 */
export const CKC_RALLY_JUMP_HEIGHT_LEVELS: string[] = [
  Constants.dog_class_element_level.advanced_a,
  Constants.dog_class_element_level.advanced_b,
  Constants.dog_class_element_level.excellent_a,
  Constants.dog_class_element_level.excellent_b,
  Constants.dog_class_element_level.master,
];

export const ckcClassUsesJumpHeight = (showType?: string, level?: string): boolean => {
  if (!showType || !level) {
    return false;
  }

  if (showType === Constants.show_type.obedience) {
    return CKC_OBEDIENCE_JUMP_HEIGHT_LEVELS.includes(level);
  }

  if (showType === Constants.show_type.rally_obedience) {
    return CKC_RALLY_JUMP_HEIGHT_LEVELS.includes(level);
  }

  return false;
};

export const akcClassUsesJumpHeight = (
  showType?: string,
  level?: string
): boolean => {
  if (!showType || !level) {
    return false;
  }

  if (showType === Constants.show_type.obedience) {
    return AKC_OBEDIENCE_JUMP_HEIGHT_LEVELS.includes(level);
  }

  if (showType === Constants.show_type.rally_obedience) {
    return AKC_RALLY_JUMP_HEIGHT_LEVELS.includes(level);
  }

  return false;
};
